<template>
<vs-row>
  <vs-col class="sm:w-3/12 pr-4">
    <vx-card>
      <vs-collapse id="leftMenu" class="p-0">

        <vs-collapse-item >
          <h4 slot="header" class="pb-4"> 페이지 </h4>

          <div v-for="(page,i) in pages" class="mb-4" :key="i">
            <vs-button @click="(event) => { handleAddCustomPageMenu(page.filename) }">{{page.filename}}</vs-button>
          </div>

        </vs-collapse-item>

        <vs-collapse-item >
          <h4 slot="header" class="py-4"> 글 </h4>
          <vs-tabs>
            <vs-tab label="공지사항">
              <div v-for="(post,i) in posts" class="mb-4" :key="i">
                <vs-button @click="(event) => { handleAddPostMenu(post) }">{{post.post_title}}</vs-button>
              </div>
            </vs-tab>

            <vs-tab label="모두보기">
              <div> 작성된 글이 없습니다.</div>
            </vs-tab>

            <vs-tab label="검색">
              <div> 작성된 글이 없습니다.</div>
            </vs-tab>
          </vs-tabs>
        </vs-collapse-item>

        <vs-collapse-item >
          <h4 slot="header" class="py-4"> 게시판 </h4>
          <vs-tabs>
            <vs-tab label="가장많이사용한">
              <div v-for="(board,i) in boardList" class="mb-4" :key="i">
                <vs-button @click="(event) => { handleAddBoardMenu(board) }">{{board.board_title}}</vs-button>
              </div>
            </vs-tab>
            <vs-tab label="모두보기">
              <div v-for="(board,i) in boardList" class="mb-4" :key="i">
                <div> 게시판이 없습니다.</div>
              </div>
            </vs-tab>
            <vs-tab label="검색">
              <div v-for="(board,i) in boardList" class="mb-4" :key="i">
                <div> 게시판이 없습니다.</div>
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-collapse-item>

        <vs-collapse-item >
          <h4 slot="header" class="py-4"> 사용자정의 링크 </h4>
          <div class="mb-4">
            <vs-input class="w-full" label="이름" v-model="customMenu.name"></vs-input>
            <vs-input class="w-full" label="URL" v-model="customMenu.url"></vs-input>
            <vs-input class="w-full" label="설명" v-model="customMenu.desc"></vs-input>
            <vs-input class="w-full" label="아이콘" v-model="customMenu.icon"></vs-input>
            <vs-button class="small flex mt-4 ml-auto" vs-align="center" color="black" @click="handleAddCustomLinkMenu">메뉴에추가</vs-button>
          </div>
        </vs-collapse-item>

        <!--  카테고리 -->
        <!--
        <vs-collapse-item >
          <h4 slot="header" class="py-4"> 카테고리 </h4>
          <vs-tabs>
            <vs-tab label="가장많이사용한">
              <div v-for="(category,i) in categorys" class="mb-4" :key="i">
                <vs-button>{{category.name}}</vs-button>
              </div>
            </vs-tab>
            <vs-tab label="모두보기">
              <div v-for="(category,i) in categorys" class="mb-4" :key="i">
                <vs-button>{{category.name}}</vs-button>
              </div>
            </vs-tab>
            <vs-tab label="검색">
              <div v-for="(category,i) in categorys" class="mb-4" :key="i">
                <vs-button>{{category.name}}</vs-button>
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-collapse-item>
        -->

        <!--  태그 -->
        <!--
        <vs-collapse-item >
          <h4 slot="header" class="pt-4"> 태그 </h4>
          <vs-tabs>
            <vs-tab label="가장많이사용한">
              <div v-for="(tag,i) in tags" class="mb-4" :key="i">
                <vs-button>{{tag.name}}</vs-button>
              </div>
            </vs-tab>
            <vs-tab label="모두보기">
              <div v-for="(tag,i) in tags" class="mb-4" :key="i">
                <vs-button>{{tag.name}}</vs-button>
              </div>
            </vs-tab>
            <vs-tab label="검색">
              <div v-for="(tag,i) in tags" class="mb-4" :key="i">
                <vs-button>{{tag.name}}</vs-button>
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-collapse-item>
        -->

      </vs-collapse>
    </vx-card>
  </vs-col>

  <vs-col class="sm:w-5/12 pl-4">
    <vx-card class="h-full">

      <div class="vx-row mb-6">
        <div class="vx-col w-full flex">
          <h5>메뉴 목록</h5>
          <vs-button class="ml-auto small" color="secondary" @click="handleMenuListUpdateClick">저장</vs-button>
        </div>
      </div>

      <DragTree :value="menuData">
        <vs-collapse id="right" class="p-0" slot-scope="{node, index, path, tree}">
          <vs-collapse-item >
            <h4 slot="header" class="">
              <vs-button class="button-item w-full flex" vs-justify="start" color="white" text-color="black"  >
                <feather-icon :icon="node.icon"></feather-icon> {{ node.name }}
              </vs-button>
            </h4>
            <div>
              <div class="vx-row mb-2">
                <div class="vx-col w-full">
                  <vs-input class="w-full" label-placeholder="이름" v-model="node.name" />
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col w-full">
                  <vs-input class="w-full" label-placeholder="URL" v-model="node.url" />
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col w-full">
                  <vs-input class="w-full" label-placeholder="설명" v-model="node.desc" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col w-full">
                  <vs-input class="w-full" label-placeholder="아이콘" v-model="node.icon" />
                </div>
              </div>
            </div>

            <div>
              <vs-row class="mb-4">
                <vs-col class="w-full flex">
                  <vs-button type="border" class="ml-auto" @click="(event) => {removeMenuItem(node)}">삭제</vs-button>
                </vs-col>
              </vs-row>
            </div>
          </vs-collapse-item>
        </vs-collapse>

      </DragTree>
    </vx-card>
  </vs-col>

</vs-row>
</template>

<script>
import 'he-tree-vue/dist/he-tree-vue.css'
import {Tree, Draggable} from 'he-tree-vue'
import vSelect from 'vue-select'

export default {
  name: 'Menu',
  components: {Tree, DragTree: Tree.mixPlugins([Draggable]), vSelect},
  data () {
    return {
      form:{boardSlug:'', boardTitle:'', boardType:''},
      pages:[],
      posts:[],
      categorys:[],
      tags:[],
      boardTypes: [],
      boardList: [],
      menuData: [],
      selected: [],
      options: ['관리자', 'bar', 'baz'],

      // form data
      customMenu: {
        url: '', // 클릭시 이동되는 URL
        name:'', // 메뉴이름
        desc:'', // 메뉴설명
        icon:'LinkIcon' //feather-icon 아이콘 이름
      }
    }
  },
  methods:{
    async loadBoardType () {
      await this.$store.dispatch('board/LOAD_BOARD_TYPE_LIST')
      this.boardTypes = this.$store.state.board.types
      if (!this.form.boardType) {
        this.form.boardType = this.boardTypes[0]
      }
    },

    async loadMenuList () {
      await this.$store.dispatch('menu/LOAD_MENU_LIST')
      this.menuData = JSON.parse(JSON.stringify(this.$store.state.menu.list))
    },

    async updateMenuList () {
      const data = JSON.stringify(this.menuData)
      await this.$store.dispatch('menu/UPDATE_MENU_LIST', data)

      location.reload()
    },

    handleMenuListUpdateClick () {
      this.updateMenuList()
    },

    handleAddCustomLinkMenu () {
      const customMenu = JSON.parse(JSON.stringify(this.customMenu))
      this.menuData.push(customMenu)

      // 작성한 내용 초기화
      this.customMenu = {
        url: '', // 클릭시 이동되는 URL
        name:'', // 메뉴이름
        desc:'', // 메뉴설명
        icon:'LinkIcon' //feather-icon 아이콘 이름
      }
    },

    handleAddCustomPageMenu (pagename) {
      const page = pagename.replace(/\.vue$/gi, '')
      this.menuData.push({
        url: `/pages/${page}`, // 클릭시 이동되는 URL
        name:page, // 메뉴이름
        desc:'', // 메뉴설명
        icon:'EditIcon' //feather-icon 아이콘 이름
      })
    },

    handleAddPostMenu (post) {
      this.menuData.push({
        url: `/board/${post.board_id}/${post.id}`, // 클릭시 이동되는 URL
        name:post.post_title, // 메뉴이름
        desc:'', // 메뉴설명
        icon:'FileTextIcon' //feather-icon 아이콘 이름
      })
    },

    handleAddBoardMenu (board) {
      this.menuData.push({
        url: `/board/${board.board_slug}`, // 클릭시 이동되는 URL
        name: board.board_title, // 메뉴이름
        desc: '', // 메뉴설명
        icon: 'ListIcon' //feather-icon 아이콘 이름
      })
    },

    removeMenuItem (item) {
      this.menuData.remove(item, true) // children까지 삭제
    }

  },
  async created () {

    await this.loadBoardType()

    // /views/pages/custom 경로에 있는 .vue 파일 리스트 가져오기
    const pages = require.context(
      '@/views/pages/custom',
      false,
      /^.*\.vue$/
    )

    for (const page of pages.keys()) {
      const pageName = page.replace('./', '')

      this.pages[this.pages.length] = {
        filename : pageName
      }
    }

    const boardId = 1
    await this.$store.dispatch('board/LOAD_POST_LIST', {boardId})
    // 게시물 불러오기
    this.posts = this.$store.state.board.postListInfo.data

    await this.$store.dispatch('board/LOAD_BOARD_LIST')
    this.boardList = this.$store.state.board.list


    this.categorys = [
      { name:'카테고리1' },
      { name:'카테고리2' },
      { name:'카테고리3' },
      { name:'카테고리4' },
      { name:'카테고리5' }
    ]

    this.tags = [
      { name : '태그1'},
      { name : '태그2'},
      { name : '태그3'},
      { name : '태그4'},
      { name : '태그5'}
    ]

    this.loadMenuList()
  }
}
</script>

<style scoped>
.vs-collapse#right .button-item:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
  padding:0
}
</style>

<style>
#leftMenu .vs-collapse-item--header,
#leftMenu .con-content--item{
  padding: 0;
}
#leftMenu .con-content--item{
  padding-top:1rem;
}
</style>
